import React, {Fragment} from 'react';

import {ObjectUtils} from "../../../../Utils";
import {usePrimeCache} from "../../../../Hooks/ServiceHooks";
import {service as SurveyQuestionDataTypeService} from "../../../../Services/SurveyQuestionDataTypeService"
import {buildAnswer} from "../../../../Hooks/SurveyFormHooks";

// TODO: get rid of this?
export const SurveyFormInputEnhance = ((ComposedComponent) => (props) => {
	const {
		ConservationAction: conservationAction,
		Question: question,
		Answer: answer = {},
		OnChange: parentOnChange,
		OnValidation: onValidation,
		Validation: validation,
	} = props;

	usePrimeCache([SurveyQuestionDataTypeService]);

	// this method is only used by SurveyFormInputBoolean and can be
	// replaced with SurveyQuestionDataTypeService calls once we
	// refactor SurveyFormInputBoolean to a functional component
	const getOptions = () => {
		const SurveyQuestionDataType = (SurveyQuestionDataTypeService.CachedValueById(question.surveyQuestionDataTypeId)?.result);

		if (!SurveyQuestionDataType) {
			return null
		}

		if (SurveyQuestionDataType.options) {
			const options = SurveyQuestionDataType?.options ?? {};
			return ObjectUtils.IsString(options) ? JSON.parse(options) : options;
		}
	}

	const onChange = (updateLogic) => {
		if (parentOnChange) {
			parentOnChange(updateLogic(buildAnswer(question, conservationAction, answer)));
		}
	}

	const setValidationStatusError = (message) => {
		if (onValidation) {
			onValidation(question.surveyQuestionId, message);
		}
	}

	return <Fragment>
		<ComposedComponent
			{...props}
			SurveyFormInput={{
				SetValidationStatusError: (message) => setValidationStatusError(message),
				MarkValidationStatusValid: () => setValidationStatusError(null),
				GetOptions: getOptions,
				GetAnswer: () => buildAnswer(question, conservationAction, answer),
				Change: onChange
			}}
		/>
		{
			validation != null ?
				<p className="sb-survey-validation-error">{validation}</p> :
				null
		}
	</Fragment>;
});
